<template>
<div class="container">
    <div class="d-md-flex gap-3 mt-3">
        <div class="col-xl-3 col-lg-4 col-md-4 mb-sm-2">
            <!-- Contenido de la columna 1 -->
            <div class="row py-2" id="card_list_sop_admi">
                <div class="px-1">
                    <div v-for="(item, index) in dataOrdenes" :key="index" @click="mtdSelectOrder(item)" class="p-3 mb-3 border border-main border-start-0 rounded-end" :class="orderSelected.id == item.id ? 'div-hover-selection' : 'div-hover'">
                        <div class="">
                            <span class="text-paciente">DR(A). {{ item.doctor.name + " " + item.doctor.last_name }}</span>
                            <br />
                            <div class="d-flex align-items-center text-xs mt-2">
                                <!--  -->
                                <i class="fas fa-calendar-alt me-2 color-icon"></i>
                                <span class="me-3">{{ item.date | formatDate }}</span>
                                <i class="fas fa-clock me-2 color-icon"></i>
                                <span class="me-3">{{ item.entry_time | formatTime }}</span>
                            </div>
                            <div class="d-flex align-items-center text-xs mt-2">
                                <i class="fas fa-user me-2 color-icon"></i>
                                <span class="me-3 fw-semibold">{{item.patient.name}}</span>
                            </div>
                            <div class="d-flex align-items-center text-xs mt-2">
                                <i class="fas fa-procedures me-2 color-icon"></i>
                                <span class="me-3 fw-semibold">{{ item.operationroom.name }}</span>
                            </div>
                            <div class="d-flex align-items-center text-xs mt-2">
                                <i class="fas fa-bed me-2 color-icon"></i>
                                <div v-if="!item.type_room" class="me-3">
                                    <span class="fw-semibold text-danger">SIN HABITACION</span>
                                </div>
                                <div v-else>
                                    <span class="fw-semibold">{{ item.type_room == 1 ? 'CUARTO INDIVIDUAL' : (item.type_room == 2 ? 'CUARTO DOBLE' : 'SIN HABITACION') }}</span>
                                    <span class="ms-1 fw-semibold text-uppercase"> / {{ item.reservation_type }} - OPERATORIO</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div v-if="dataOrdenes.length == 0" class="p-3 mb-3 border border-main border-start-0 rounded-end">
                        <h5 class="color-main">NO HAY ORDENES</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-9 col-lg-8 col-md-8 mb-sm-2 px-2">
            <!-- Contenido de la columna 2 - carrito -->
            <div class="row h-100 p-2">
                <div class="card px-0 w-100">
                    <div class="card-header bg-main text-center text-white">
                        <h5 class="card-title">PROGRAMAR CITA {{ orderSelected.patient ? "PARA " + orderSelected.patient.name : "" }}</h5>
                    </div>
                    <div class="card-body" style="background-color: #e6e6e6">
                        <div class="row" id="div-modal-venta">
                            <div :class="showRoom? 'col-md-8' : 'col-md-12'" v-show="showFloors">
                                <div class="card-body">
                                    <div class="d-flex justify-content-center my-3">
                                        <ul class="nav nav-pills text-center">
                                            <li v-for="(item, index) in dataFloor" :key="index" class="nav-item px-1 mt-2" @click="mtdSelectGroup(item.id)">
                                                <a :class="tab == item.id ? 'nav-link active' : 'nav-link'" aria-current="page">{{ item.name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="row mt-4 px-1" v-if="tab != 0">
                                        <div class="d-lg-flex flex-wrap justify-content-evenly">
                                            <!-- CAMAS EN GRUPO -->
                                            <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 p-1" v-for="(itemg, index) in dataGroupsShow" :key="index" :style="'max-height: ' +
                    200 * itemg.beds.length +
                    'px'
                    ">
                                                <div class="card bg-card-bed">

                                                    <div v-for="(itemd, indexb) in itemg.beds" :key="indexb">
                                                        <div class="d-md-flex g-0 align-items-center">
                                                            <div class="col-md-5 col-sm-12">
                                                                <img class="img-fluid-bed py-2" src="../../../assets/cama_sin_fondo.png" alt="" />
                                                            </div>
                                                            <div class="col-md-7 col-sm-12">
                                                                <div class="card-body text-center">
                                                                    <div v-if="itemd.id == orderSelected.bed_id">
                                                                        <div v-if="mostrar == true">
                                                                            <span class="card-text h6 circle text-white" v-if="itemd.id == orderSelected.bed_id" style="background: orange">{{ itemd.name }} </span>

                                                                        </div>
                                                                        <div v-else>
                                                                            <span class="card-text h6 circle text-white" @click="mtdReserveHour(itemd.id, index, indexb)" v-if="itemd.status == 1" style="background: #39b54a">{{ itemd.name }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-else>
                                                                        <span class="card-text h6 circle text-white" @click="mtdReserveHour(itemd.id, index, indexb )" v-if="itemd.status == 1 && itemd.name != 'AUX'" style="background: #39b54a">{{ itemd.name }} </span>
                                                                        <span class="card-text h6 circle text-white" @click="mtdReserveAuxiliar(itemd.id, index, indexb)" v-if="itemd.status == 1 && itemd.name == 'AUX'" style="background: #39b54a">{{ itemd.name }} </span>
                                                                        <span class="card-text h6 circle text-white" v-else-if="itemd.status == 2" style="background: #ff0000">{{ itemd.name }}</span>
                                                                        <span class="card-text h6 circle text-white" v-else-if="itemd.status == 3" style="background: #00b8ff">{{ itemd.name }}</span>
                                                                        <span class="card-text h6 circle text-white" v-else-if="itemd.status == 4" style="background: #fcee21">{{ itemd.name }}</span>
                                                                        <span class="card-text h6 circle text-white" v-else-if="itemd.status == 5" style="background: orange">{{ itemd.name }}</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- contenido para la sala -->
                            <div class="border-start" v-show="showRoom" :class="showFloors ? 'col-md-4' : 'col-md-12'">
                                <div class="row mt-2 p-2">
                                    <div class="card bg-white border border-main">
                                        <div class="card-body">
                                            <h5 class="text-center card-title color-main">{{ orderSelected.operationroom ? orderSelected.operationroom.name : ""}}</h5>
                                            <div class="mb-3">
                                                <label for="fechaSala" class="form-label">Fecha</label>
                                                <input type="date" class="form-control" id="fechaSala" v-model="orderSelected.date" disabled>
                                            </div>
                                            <div class="mb-3">
                                                <label for="horaSala" class="form-label">Hora</label>
                                                <input type="time" class="form-control" id="horaSala" v-model="orderSelected.entry_time" disabled>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer bg-main text-white">
                        <div class="d-flex justify-content-end">
                            <!-- total de la venta -->
                             <div class="me-3 px-2 align-self-center">
                                <h5 class="fw-bold">Total: S/. {{ mtdTotal()  }}</h5>
                             </div>
                            <div>
                                <button class="btn btn-light color-main" :disabled="!orderSelected.patient" @click="mtdSaveBooking">Guardar</button> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import moment from 'moment';
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
export default {
    name: 'c-admision-OrdenesSop',
    components: {
        SweetAlert
    },
    data() {
        return {
            swal: null,
            filter: {
                date_start: "",
                date_end: "",
                type: ["1"],
            },
            dataOrdenes: [],
            dataFloor: [],
            orderSelected: {},
            tab: -1,
            dataBedGroupsD: [],
            dataGroupsShow: [],
            oldPosSelectBed: [],
            showFloors: true,
            showRoom: false,
            mostrar: false,
            verifSelectBed: false,
            data_product_filter: [],

        }
    },
    created() {
        this.getFirstDayOfMonth();
    },
    methods: {
        ...mapActions(["get", "post"]),
        getFirstDayOfMonth: function () {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 2);
            this.filter.date_start = firstDayOfMonth.toISOString().split('T')[0];
            this.filter.date_end = today.toISOString().split('T')[0];
            this.mtdGetData();
            this.mtdGetDataFloor();
        },
        //Traer Data
        mtdGetData: function () {
            this.post({
                    url: this.$store.getters.get__url + "/Sop/ListOrderSop",
                    token: this.$store.getters.get__token,
                    params: this.filter,
                })
                .then((response) => {
                    this.dataOrdenes = response.data;
                    //this.calculateData(10);
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
        },
        mtdSelectOrder(item) {
            this.orderSelected = item;
            this.oldPosSelectBed.bed_id = null;
            this.showFloors = item.reservation_type == 'pre' ? true : false;
            this.showRoom = item.reservation_type == 'pre' ? false : true;
            this.mtdShowGroupBeds();
            this.mtdSearchSubsubcategory();
        },
        //Traer informacion sobre las camas
        mtdGetDataFloor: function () {
            this.get({
                    url: this.$store.getters.get__url + "/Venta/floor/" + this.$store.getters.get__campus,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    let floors = response.data;
                    //filtrar piso de hospi
                    this.dataFloor = floors.filter((floor) => floor.name.includes("HOSPI"));

                })
                .catch((errors) => {});
        },
        //traer informacion sobre la subsubcategoria
        mtdSearchSubsubcategory: function () {
            let type = 'particular';
            let insurance = null;
            let search_product = this.orderSelected.reservation_type == 'pre' ? (this.orderSelected.type_room == 1 ? 'CUARTO INDIVIDUAL CAMA INDIVIDUAL' 
                : 'CUARTO DOBLE CAMA BIPERSONAL') : this.orderSelected.operationroom.name;
            
            this.get({
                    url: this.$store.getters.get__url +
                        "/cxc/" +
                        type +
                        "/" +
                        insurance +
                        "/subsubcategoriesCxc?search_product=" +
                        search_product,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.data_product_filter = response.data;
                })
                .catch((errors) => {});
        },
        mtdSelectGroup: function (id) {
            if (!this.orderSelected.id) {
                this.$refs.SweetAlert.showWarning("Seleccione una orden");
                return;
            } else {
                this.post({
                        url: this.$store.getters.get__url + "/Venta/bedgroup/filter",
                        token: this.$store.getters.get__token,
                        params: {
                            floor_id: id,
                        },
                    })
                    .then((response) => {
                        this.dataBedGroupsD = response.data.bedgroups_details;
                        this.tab = id;
                        this.mtdShowGroupBeds();

                    })
                    .catch((errors) => {});
            }
        },
        //mostrar solo los grupos necesarios
        mtdReserveHour: function (bed, pos1, pos2) { //pos1->grupo , pos2->cama
            if (this.dataGroupsShow[pos1].beds[pos2].status == 1) {
                if (this.verifSelectBed == true) {
                    //verificar si es un grupo del mismo piso
                    if (this.oldPosSelectBed[2] != this.tab) {
                        this.mtdBehindGroup(this.oldPosSelectBed);
                    } else {
                        this.dataGroupsShow[this.oldPosSelectBed[0]].beds[this.oldPosSelectBed[1]].status = 1;
                    }
                }
                this.oldPosSelectBed = [pos1, pos2, this.tab];
                this.verifSelectBed = true;
                this.dataGroupsShow[pos1].beds[pos2].status = 4;
            }
            this.orderSelected.bed_id = bed;
            this.mostrar = true;
        },
        mtdBehindGroup: function (data) {
            this.post({
                    url: this.$store.getters.get__url + "/Venta/bedgroup/filter",
                    token: this.$store.getters.get__token,
                    params: {
                        floor_id: data[2],
                    },
                })
                .then((response) => {
                    let dataBedGroupsD;
                    dataBedGroupsD = response.data.bedgroups_details;
                    dataBedGroupsD[data[0]].beds[data[1]].status = 1;
                })
        },
        mtdShowGroupBeds: function () {
            //verificar si es cama individual o doble
            this.dataGroupsShow = [];
            if (this.orderSelected.type_room == 2) {
                this.dataBedGroupsD.forEach(element => {
                    if (element.beds.length > 1) {
                        this.dataGroupsShow.push(element);
                    }
                });
            } else {
                this.dataBedGroupsD.forEach(element => {
                    if (element.beds.length == 1) {
                        this.dataGroupsShow.push(element);
                    }
                });
            }
        },
        mtdSaveBooking: function (){
            //validar si se selecciono una cama
            if(this.orderSelected.reservation_type == 'pre' && !this.orderSelected.bed_id){
                this.$refs.SweetAlert.showWarning("Seleccione una cama");
                return;
            }
            let params = {
                order_selected: this.orderSelected,
                data_products: this.data_product_filter[0],
                campu_id: this.$store.getters.get__campus,

            }
            console.log(params);
            this.post({
                    url: this.$store.getters.get__url + "/Admision/SaveBookingSop",
                    token: this.$store.getters.get__token,
                    params: params,
                })
                .then((response) => {
                    this.$refs.SweetAlert.showSuccess("Cita programada correctamente");
                    this.orderSelected = {};
                    this.mtdGetData();
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
        },
        mtdTotal(){
            let total = 0;
            this.data_product_filter.forEach(element => {
                total += parseInt(element.precio_farmacia_particular);
            });
            return total.toFixed(2);
        }
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatTime(time) {
            let arTime = time.split(":");
            if (arTime[0] <= 12) {
                return time + " am";
            } else {
                return arTime[0] - 12 + ":" + arTime[1] + " pm";
            }
        },
    },

};
</script>
